import type { State } from "./reducers/user";
export const getIsAuthenticated = (state: { user: State }) =>
  state.user.userState === "authenticated";
export const getIsKnown = (state: { user: State }) =>
  state.user.userState !== "unknown" && state.user.userState != null;
export const getAuthenticatedUserId = (state: { user: State }) =>
  state.user.userId;
